import gql from 'graphql-tag';

export const GET_FILE_BY_TYPE_CLAVE_FILENAME = gql(`
query getFileByTypeAndClaveAndFilename ($type: String,$clave: String,$filename: String) {
    getFileByTypeAndClaveAndFilename(type: $type, clave:$clave, filename:$filename) {
        filename
        base64
    }
}
`);

export const GET_LIST_FILES_BY_TYPE_CLAVE = gql(`
query getListFileByTypeAndClave($type: String,$clave: String) {
    getListFileByTypeAndClave(type: $type, clave:$clave) {
        filename
        base64
    }
}
`);

export const GET_LIST_FILES_BY_TYPE_CLAVE_FILENAME = gql(`
query getFileByTypeAndClaveAndFilename($type: String,$clave: String, $filename: String) {
   getFileByTypeAndClaveAndFilename(type: $type, clave:$clave, filename:$filename) {
        filename
        base64
   }
}
`);

export const DOWNLOAD_FILE = gql(`
    query getFileById($id: Long) {
        getFileById(id: $id) {
           base64
           filename
        }
    }
`);

export const GET_FILES_LIST = gql(`
    query listaDocumento($criteria: ItemCriteriaInput) {
        listaDocumento(criteria: $criteria) {
            totalElements
            results{
                id
                tipo
                clave
                filename
                fechaAlta
            }
        }
    }
`);


export const DELETE_FILE_BY_ID = gql(`
    mutation deleteFileById($id: Long) {
        deleteFileById(id: $id) {
            status
        }
    }
`);

export const GET_FILE_BY_ID = gql(`
   query getFileById($id: Long) {
      getFileById(id: $id) {
         base64,
         filename
      }
    }
`);